var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-swiper-slide',{class:_vm.$style.slide,nativeOn:{"click":function($event){return _vm.goToGift.apply(null, arguments)}}},[_c('div',{class:_vm.$style.content,style:(_vm.styles)},[_vm._v(_vm._s(_vm.gift.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }